import {QueryCommand} from "xmgoing-server";
import SysConfigUtils from "@/utils/sysConfigUtils";



/**
 * 根据pageId获取明细信息
 */
export const loadDetailByPageIdApi=function ({pageId},backFun){
  //获取界面id
  const queryCommand = new QueryCommand({
    method: "GET",
    url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/menuInfoSettingAct/detail'
  });
  //执行查询操作
  queryCommand.executeQuery({
    params: {id: pageId}, successFun: (datas) => {
      backFun&&backFun(datas);
    }
  });
}
/**
 * 获取业务领域里面的设计信息
 * @param props
 * @param recordId
 * @param backFun
 */
export const loadContentById = function ({props,recordId},backFun) {
  const queryCommand = new QueryCommand({
    url: `/api/go-lcc/execute/detailByTableCode/${unref(props).tableCode}`,
    method: 'POST',
    showTip: false,
  });
  queryCommand.executeQueryPromise({params: {id:recordId}}).then((res) => {
    if (res.formJson) {
      backFun&&backFun(res);
    }
  })
}


/**
 *
 */
export const loadDesPageConfigInfosFromDb=function ({pageCode},backFun){
  //获取界面id
  const queryCommand = new QueryCommand({
    method: "GET",
    url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/baseConfig/getByPageCode'
  });
  //执行查询操作
  queryCommand.executeQuery({
    params: {pageCode}, successFun: (datas) => {
      backFun&&backFun(datas);
    }
  });
}
